<template>
  <BookmarkCard :tag-type="tagType" icon-name="pencil-ruler">
    <template #content>
      <div v-if="localProject.etablissements[0]" class="EtablissementProjectCard-text">
        {{ localProject.etablissements[0].nom }}
      </div>
      <div class="EtablissementProjectCard-text">{{ localProject.natureAireEducative }}</div>
      <div class="EtablissementProjectCard-text name">{{ localProject.nom }}</div>
    </template>
    <template #footer>
      <div class="buttons EtablissementProjectCard-buttons">
        <b-button v-if="!projectJoined" type="is-primary" rounded @click="joinProject"
          >{{ $t("join") }}
        </b-button>
        <div v-if="projectJoined" class="EtablissementProjectCard-joined" @click="leaveProject">
          {{ $t("myProjects.joined") }}
          <b-icon icon="check-circle" size="is-large" type="is-success" />
        </div>
      </div>
    </template>
  </BookmarkCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import BookmarkCard from "../generic_components/BookmarkCard.vue"
import { TAG_TYPES_FOR_BOOKMARK_CARD } from "@/model/bean/EnumHelper"
import { ProjetAnnuelDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { BButton, BIcon } from "buefy"

export default defineComponent({
  name: "EtablissementProjectCard",
  components: {
    BookmarkCard,
    BButton,
    BIcon,
  },
  props: {
    project: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    loggedUser: {
      type: Object as PropType<UtilisateurDTO>,
      required: true,
    },
  },

  emits: ["update-project"],
  data() {
    return {
      localProject: { ...this.project } as ProjetAnnuelDTO,
      projectJoined: false,
      tagType: TAG_TYPES_FOR_BOOKMARK_CARD.JOIN,
    }
  },
  watch: {
    project: {
      handler(newVal: ProjetAnnuelDTO) {
        this.localProject = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    joinProject(): void {
      this.projectJoined = true
      this.localProject.enseignants.push(this.loggedUser)
      if (this.localProject.consentementValide === null) {
        this.localProject.consentementValide = []
      }
      if (this.loggedUser.id) {
        this.localProject.consentementValide.push(this.loggedUser.id)
      }

      this.$emit("update-project", this.localProject)
    },

    leaveProject(): void {
      this.projectJoined = false
      this.localProject.enseignants = this.localProject.enseignants.filter(
        (ens) => ens.id != this.loggedUser.id,
      )
      this.localProject.consentementValide = this.localProject.consentementValide.filter(
        (id) => id != this.loggedUser.id,
      )

      this.$emit("update-project", this.localProject)
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.EtablissementProjectCard-buttons {
  width: 100%;
  padding: 0 0.25rem;

  &.buttons {
    justify-content: flex-end;

    .button {
      min-width: 57px;
      text-transform: uppercase;
    }
  }
}

.EtablissementProjectCard-text {
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  &.name {
    font-weight: 700;
  }
}

.EtablissementProjectCard-joined {
  display: flex;
  align-items: center;
  font-style: italic;
  color: $success;
  cursor: pointer;
}
</style>
